import { getRequest } from './http'
import config from '../config'

type CouncilInfo = {
  councilName: string
  contactName: string
  councilId: string
  email: string
  phoneNumber: string
  fax: string
}

export async function getCouncilContactInfo(lgaId: string) {
  const councilContactInfo = await getRequest<CouncilInfo>({
    url: `${config.HOSTED_API_URL}/council-contact-info/${lgaId}`,
  })

  return councilContactInfo
}
